function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M255.987,20c-5.522,0-10,4.477-10,10v59.493c0,5.523,4.478,10,10,10c5.522,0,10-4.477,10-10V30 C265.987,24.477,261.509,20,255.987,20z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M199.324,105.381l-23.926-23.905c-3.909-3.904-10.239-3.901-14.143,0.006c-3.903,3.907-3.9,10.238,0.006,14.142 l23.927,23.905c1.953,1.951,4.511,2.926,7.068,2.926c2.561,0,5.121-0.978,7.074-2.932 C203.233,115.616,203.23,109.285,199.324,105.381z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M350.738,81.5c-3.907-3.905-10.239-3.901-14.143,0.005l-25.437,25.457c-3.903,3.907-3.9,10.238,0.006,14.142 c1.953,1.952,4.512,2.927,7.069,2.927c2.561,0,5.121-0.978,7.074-2.932l25.437-25.457C354.647,91.735,354.644,85.404,350.738,81.5 z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M446.5,284h-8.07c6.586-8.585,10.513-19.312,10.513-30.943v-14.113C448.943,210.853,426.09,188,398,188 c-28.09,0-50.943,22.853-50.943,50.943v10.971l-75.231-75.232c-4.175-4.174-10.315-5.514-15.825-3.524 c-5.508-1.99-11.65-0.65-15.826,3.525l-75.23,75.231v-10.971C164.943,210.853,142.09,188,114,188 c-28.09,0-50.943,22.853-50.943,50.943v14.113c0,11.632,3.927,22.358,10.513,30.943H65.5C29.383,284,0,313.383,0,349.5V482 c0,5.523,4.478,10,10,10h42.25c1,0,1.964-0.151,2.875-0.424C56.036,491.849,57,492,58,492h112c5.522,0,10-4.477,10-10v-34 c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10v24H68V358.053c0-5.523-4.478-10-10-10s-10,4.477-10,10V472H20V349.5 c0-25.089,20.411-45.5,45.5-45.5H135c2.752,0,5.244-1.113,7.052-2.911c0.007-0.007,0.013-0.011,0.02-0.017l103.869-103.87 c-0.681,20.768-7.141,40.771-18.787,58.068l-65.448,97.198c-1.111,1.651-1.705,3.596-1.705,5.585V369c0,5.523,4.478,10,10,10 c5.522,0,10-4.477,10-10v-7.895l63.743-94.666c4.87-7.233,8.954-14.875,12.257-22.808c3.303,7.933,7.386,15.575,12.257,22.808 L332,361.105V482c0,5.523,4.478,10,10,10h112c1,0,1.964-0.151,2.875-0.424c0.911,0.273,1.875,0.424,2.875,0.424H502 c5.522,0,10-4.477,10-10V349.5C512,313.383,482.617,284,446.5,284z M144.943,253.056c0,17.063-13.88,30.944-30.943,30.944 s-30.943-13.881-30.943-30.943v-14.113C83.057,221.881,96.938,208,114,208s30.943,13.881,30.943,30.943V253.056z M367.057,238.943 C367.057,221.881,380.938,208,398,208s30.943,13.881,30.943,30.943v14.113c0,17.063-13.88,30.944-30.943,30.944 s-30.943-13.881-30.943-30.943V238.943z M492,472L492,472h-28v-74c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10v74h-92V358.053 c0-1.99-0.594-3.935-1.705-5.585l-65.448-97.197c-11.646-17.297-18.106-37.3-18.787-58.068l103.869,103.869 c0.132,0.132,0.256,0.243,0.376,0.342c1.773,1.603,4.117,2.588,6.695,2.588h69.5c25.089,0,45.5,20.411,45.5,45.5V472z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M461.069,350.98c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07 s1.069,5.21,2.93,7.07c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07 S462.93,352.85,461.069,350.98z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M177.069,403.93C175.21,402.07,172.63,401,170,401s-5.21,1.07-7.07,2.93S160,408.37,160,411s1.069,5.21,2.93,7.07 c1.861,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07S178.93,405.79,177.069,403.93z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

export default __webpack_public_path__ + "static/media/highfive.f89d8a06.svg";
export { SvgComponent as ReactComponent };